import { render, staticRenderFns } from "./SsoMicrosoftLogin.vue?vue&type=template&id=4547afda&"
import script from "./SsoMicrosoftLogin.vue?vue&type=script&lang=js&"
export * from "./SsoMicrosoftLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports